<!--
 * @Author:
 * @LastEditTime: 2024-02-25 22:10:12
 * @Description: 新增、编辑模型
-->
<template>
  <div>
    <el-dialog
      class="mid-dialog"
      v-dialogDrag
      :append-to-body="true"
      :visible.sync="modelProps.visible"
      :title="modelProps.title"
      :close-on-click-modal="false"
      @close="close(false)"
    >
      <el-form
        :model="modelContextForm"
        :rules="modelTreeFormRules"
        ref="modelForm"
        label-width="150px"
        :disabled="modelProps.editType === 'read'"
      >
        <el-form-item :label="`${pageTitle}序号`" prop="orderNumber">
          <el-input
            v-model.number="modelContextForm.orderNumber"
            oninput="value = value.replace(/[^\d.]/g,'')"
            :placeholder="`请选择${pageTitle}序号`"
            size="small"
            clearable
          />
        </el-form-item>
        <el-form-item :label="`${pageTitle}分类`" prop="directoryId">
          <el-select
            ref="modelTree"
            v-model="modelContextForm.modelClassName"
            class="mr-10px w-200px"
            popper-class="modeltree__select"
            :popper-append-to-body="false"
            :placeholder="`请选择${pageTitle}分类`"
            clearable
            filterable
          >
            <el-option
              v-for="item in flatTreeData"
              :key="item.id"
              :value="item.id"
              :label="item.name"
              class="hidden"
            ></el-option>
            <el-tree
              ref="modelClassTree"
              :data="treeData"
              :props="{
                children: 'children',
                label: 'name',
              }"
              :expand-on-click-node="false"
              :default-expanded-keys="['']"
              @node-click="treeNodeClick"
              node-key="id"
              highlight-current
            ></el-tree>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${pageTitle}名称`" prop="name">
          <el-input
            v-model.trim="modelContextForm.name"
            :placeholder="`请选择${pageTitle}名称`"
            size="small"
            clearable
          />
        </el-form-item>
        <el-form-item :label="`${pageTitle}标签`" prop="lables">
          <div class="max-w-440px flex justify-start flex-wrap">
            <el-tag
              class="h-36px mr-10px mb-10px mt-2px flex items-center text-14px"
              v-for="tag in modelContextForm.lables"
              @close="handleClose(tag)"
              :key="tag"
              :disable-transitions="false"
              closable
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="!w-84px"
              v-if="inputVisible"
              v-model.trim="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button v-else class="my-2px inline-block" size="small" @click="showInput"
              >+新标签</el-button
            >
          </div>
        </el-form-item>
        <el-form-item :label="`上传${pageTitle}文件`" prop="modelFile">
          <UploadChunkFile
            v-loading="uploadLoading"
            :element-loading-text="uploadProgressText"
            v-model="modelContextForm.modelFile"
            :maxFileCount="1"
            :fileAccept="materialType === 1 ? 'pr,fbx,pprj' : 'efk'"
            :singleFile="true"
            @on-progress="onUploadProgress"
            @on-error="uploadLoading = false"
            @filesUploadComplete="onUploadSuccess"
            :disabled="tableFormDisabled"
            :fileMedias="fileMedias"
            :chunkSize="chunkSize"
            ref="uploadChunk"
          ></UploadChunkFile>
        </el-form-item>
        <el-form-item :label="`上传${pageTitle}贴图`" prop="modelMaps">
          <form-upload
            v-model="modelContextForm.modelMaps"
            :maxSize="chartletSize"
            :accept="['zip']"
            :disabled="tableFormDisabled"
            :fileMedias="fileMedias"
          ></form-upload>
        </el-form-item>
        <el-form-item :label="`上传${pageTitle}缩略图`" prop="modelPic">
          <form-upload
            v-model="modelContextForm.modelPic"
            :maxSize="10"
            :accept="['png', 'jpg']"
            :disabled="tableFormDisabled"
            :fileMedias="fileMedias"
          ></form-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center" v-if="modelProps.editType !== 'read'">
        <el-button size="small" type="primary" @click="save()" :loading="saveLoading"
          >保存</el-button
        >
        <el-button size="small" @click="close(false)">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { ModelApi, AnimationApi } from '@wiz-api/material-management'
import {
  isArray,
  reject,
  map,
  keys,
  eq,
  split,
  cloneDeep,
  fromPairs,
  indexOf,
  includes,
  get,
  assign,
  filter,
  find,
} from 'lodash'
import UploadChunkFile from '@/components/UploadFile/UploadChunkFile'

const modelApi = new ModelApi()
const animationApi = new AnimationApi()

const FormUpload = () => {
  return import('./FormUpload')
}

export default {
  name: 'operateModelDialog',
  components: {
    FormUpload,
    UploadChunkFile,
  },
  props: {
    // 当前选中目录
    currentTreeSelect: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 弹框操作类型
    modelProps: {
      type: Object,
      default: () => {
        return {
          visible: true,
          title: '新增模型',
          editType: 'create',
        }
      },
    },
    // 查看、编辑表
    modelForm: {
      type: Object,
      default: () => {
        return {
          name: '',
          orderNumber: '',
          directoryId: '',
          lables: [],
          modelFile: '',
          modelClassName: '',
        }
      },
    },
    // 分类树
    treeData: {
      type: Array,
      default: () => {
        return []
      },
    },
    flatTreeData: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 页面信息 默认为模型库页面
    pageInfo: {
      type: Object,
      default: () => {
        return {
          pageTitle: '模型',
          materialType: 1,
        }
      },
    },
  },
  data() {
    return {
      uploadProgressText: '',
      uploadLoading: false,
      // 表单
      modelContextForm: {
        name: '',
        orderNumber: '',
        directoryId: '',
        lables: [],
        modelFile: '',
        modelClassName: '',
      },
      // 查看屏蔽标签新增
      inputVisible: false,
      // 输入框内容
      inputValue: '',
      // 表单保存状态
      saveLoading: false,
      // 请求实例
      requestInstance: null,
      // 文件列表信息
      fileMedias: [],
      tableFormDisabled: false,
    }
  },
  computed: {
    // 弹框标题
    pageTitle() {
      return get(this.pageInfo, 'pageTitle')
    },
    // 弹框类型
    materialType() {
      return get(this.pageInfo, 'materialType')
    },
    // 表单校验规则
    modelTreeFormRules() {
      return {
        orderNumber: [
          {
            required: true,
            message: `请输入${this.pageTitle}序号`,
            trigger: ['blur', 'change'],
          },
        ],
        directoryId: [
          {
            required: true,
            message: `请选择${this.pageTitle}分类`,
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: `请输入${this.pageTitle}名称`,
            trigger: ['blur', 'change'],
          },
        ],
        modelFile: [
          {
            required: true,
            message: `请上传${this.pageTitle}文件`,
            trigger: 'change',
          },
        ],
      }
    },
    chartletSize() {
      const currentEnv = Wiz.GetModuleConfig('source-material-management').currentEnv
      return currentEnv?.chartletSize || 30
    }, // 贴图size大小
    // 上传分片大小
    chunkSize() {
      const config = Wiz.globalSettings.dynamicModules.modules['source-material-management']?.config || {}
      return config.chunkSize || 2 // 默认2M
    },
  },
  methods: {
    onUploadProgress(progress) {
      this.uploadLoading = true
      this.uploadProgressText = `已完成${progress}%`
    },

    onUploadSuccess(file) {
      this.uploadLoading = false
      this.modelContextForm.modelFile = file.id
    },

    // 初始化表单数据
    async initFormData() {
      // 如果为新建自动带上模型库目录信息
      const createInfo = {
        modelClassName: this.currentTreeSelect.path || '',
        directoryId: this.currentTreeSelect.id || '',
      }
      const formId = get(this.modelForm, 'id')

      let lableObj = {
        lables: [],
      }

      let currentModelObj = {}

      if (includes(['edit', 'read'], this.modelProps.editType) && formId) {
        // 标签转换为数组
        lableObj = {
          lables: filter(split(this.modelForm.lables, ';'), Boolean),
        }
        currentModelObj = await this.getFormDetail(formId)
      }

      this.modelContextForm = assign(
        currentModelObj,
        cloneDeep(this.modelForm),
        // 新建传入树路径
        eq(this.modelProps.editType, 'create') ? createInfo : {},
        // 标签转换为数组
        lableObj
      )
    },
    // 下拉数形点击
    treeNodeClick(node) {
      this.modelContextForm.directoryId = node.id
      this.modelContextForm.modelClassName = node.path
      this.$refs.modelTree.blur()
      this.$refs.modelForm.validateField(['directoryId'])
    },
    // 标签删除
    handleClose(tag) {
      if (!isArray(this.modelContextForm.lables)) {
        return
      }
      this.modelContextForm.lables.splice(indexOf(this.modelContextForm.lables, tag), 1)
    },
    // 标签添加聚焦
    showInput() {
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    // 新增标签校验
    handleInputConfirm() {
      if (includes(this.modelContextForm.lables, this.inputValue)) {
        this.$message.warning('已存在该标签')
        return
      }
      if (get(this.modelContextForm.lables, 'length') > 20) {
        this.$message.warning('标签数量已超过最大限制')
        return
      }
      if (this.inputValue) {
        this.modelContextForm.lables.push(this.inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    // 关闭弹框事件
    close(isUpdated) {
      this.$emit('closeModelDialog', isUpdated)
    },
    // 表单保存
    save() {
      this.$refs.modelForm.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          const body = assign(this.modelContextForm, {
            medias: this.transformMedias(),
          })
          if (this.modelProps.editType === 'create') {
            const [err] = await this.requestInstance.create({
              body,
            })
            this.saveLoading = false
            if (!err) {
              this.$message.success(`新增${this.pageTitle}成功`)
              this.close(true)
            }
            return
          }
          const [err] = await this.requestInstance.update(this.modelContextForm.id, {
            body: this.modelContextForm,
          })
          this.saveLoading = false
          if (!err) {
            this.$message.success(`修改${this.pageTitle}成功`)
            this.close(true)
          }
        }
      })
    },
    // 表单文件id处理
    transformMedias() {
      const currentFileIds = this.modelContextForm.medias
      const { materialType } = this.$route.meta
      const mediaType = {
        modelFile: 1,
        modelMaps: 2,
        modelPic: 3,
      }
      return reject(
        map(keys(mediaType), (item) => {
          const targetItem = find(currentFileIds, ['mediaType', mediaType[item]])
          const id = get(targetItem, 'id')
          return assign(id ? { ...targetItem } : {}, {
            fileInfoId: this.modelContextForm[item] || '',
            mediaType: mediaType[item],
            [materialType === 1 ? 'modelId' : 'animationId']: this.modelContextForm.id || null,
          })
        }),
        ['fileInfoId', '']
      )
    },
    // 获取表单文件数据
    getFormDetail() {
      const medias = get(this.modelForm, 'medias')
      this.fileMedias = cloneDeep(medias)
      if (!get(medias, 'length')) {
        return {}
      }
      const typeFiles = ['', 'modelFile', 'modelMaps', 'modelPic']
      const resFiles = map(medias, (item) => {
        const { fileInfoId, mediaType } = item
        return [typeFiles[mediaType], fileInfoId]
      })
      return fromPairs(resFiles)
    },
  },
  created() {
    const { materialType } = this.$route.meta
    switch (materialType) {
      case 1:
        this.requestInstance = modelApi
        break
      case 2:
        // 动效管理时替换 api为animationApi
        this.requestInstance = animationApi
        break
      default:
        break
    }
    // 初始化表单数据
    this.initFormData()
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .modeltree__select {
    width: 440px;
    .el-select-dropdown__empty {
      display: none;
    }
  }
}
</style>
